import React, { useState, useMemo, useEffect } from "react"
import { Row, Col, Card, Table } from "reactstrap"
import {
    useTable,
    useSortBy,
    usePagination,
    useGlobalFilter,
} from "react-table"
// assets
import Loader from "pages/Separate/Loader"
import NewPagination from "components/Common/Newpagination"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import { customGlobalFilter } from "utils/common-helpers"
import ReplyIndex from "pages/WorkModule/Support/Tickets/Reply/ReplyIndex"
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable"
import { codeReviewQueriesColumn } from "utils/columns/Support/developerTicketColumns"
import Swal from "sweetalert2"

function TableContainer({ columns, data, allData, setData }) {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        state,
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
        gotoPage,
        setPageSize,
        pageOptions,
        setGlobalFilter,
        pageCount,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
            globalFilter: customGlobalFilter,
            initialState: {
                sortBy: [
                    {
                        id: "id",
                        desc: true,
                    },
                ],
            },
        },

        useGlobalFilter,
        useSortBy,
        usePagination
    )
    const { pageIndex, pageSize, globalFilter } = state

    useEffect(() => {
        setPageSize(10)
    }, [])

    return (
        <div>
            <Row>
                <Col xl="12">
                    <div className="card-body ">
                        <div className="d-flex mb-2 align-items-start gap-3">
                            <div className="mb-3 text-purple fs-5  fw-bold">Code Review Queries</div>
                        </div>
                        <Row className="mb-2 justify-content-between">
                            <div className="mb-3 mb-md-0 d-flex justify-space-between align-items-center">
                                <div className="col-1 me-md-5">
                                    <select
                                        className="border-radius form-select"
                                        style={{ width: "100px" }}
                                        value={pageSize}
                                        onChange={e => setPageSize(e.target.value)}
                                    >
                                        {[10, 25, 50, 100].map(pageSize => (
                                            <option key={pageSize} value={pageSize}>
                                                Show {pageSize}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-10 d-flex justify-content-end align-items-center">
                                    <div className="col-4 cusrtom_search_box">
                                        <div className="search-box me-xxl-2 my-xxl-0 d-inline-block w-100">
                                            <div className="d-flex">
                                                <div className="position-relative w-100">
                                                    <label
                                                        htmlFor="search-bar-0"
                                                        className="search-label w-100 mb-0"
                                                    >
                                                        <span id="search-bar-0-label" className="sr-only">
                                                            Search this table
                                                        </span>
                                                        <input
                                                            onChange={e => setGlobalFilter(e.target.value)}
                                                            id="search-bar-0"
                                                            type="text"
                                                            className="border-radius form-control rounded h-100 w-100"
                                                            placeholder={`Search...`}
                                                            value={globalFilter || ""}
                                                        />
                                                    </label>
                                                    <i className="bx bx-search-alt search-icon"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <div className="position-relative table-responsive">
                            <Table className="table table-bordered mt-4" {...getTableProps()}>
                                <thead>
                                    {headerGroups.map((headerGroup, i) => (
                                        <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                                            {headerGroup.headers.map((column, index) => {
                                                const classNames = column.className
                                                return (
                                                    <th
                                                        key={index}
                                                        className={`col-t-${index + 1} ${classNames} ${index != 0 && "customShortIcon"
                                                            }`}
                                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                                    >
                                                        <div>
                                                            {column.render("Header")}
                                                            {column.isShortIcon ? (
                                                                <span
                                                                    style={{
                                                                        display: index == 0 ? "none" : "block",
                                                                    }}
                                                                    onClick={() =>
                                                                        column.getSortByToggleProps().onClick()
                                                                    }
                                                                >
                                                                    <i
                                                                        title="Ascending"
                                                                        className={`bi bi-arrow-up ms-1 info-icon ${column.isSorted && !column.isSortedDesc
                                                                            ? "text-dark"
                                                                            : ""
                                                                            }`}
                                                                    ></i>
                                                                    <i
                                                                        title="Descending"
                                                                        className={`bi bi-arrow-down info-icon ${column.isSorted && column.isSortedDesc
                                                                            ? "text-dark"
                                                                            : ""
                                                                            }`}
                                                                    ></i>
                                                                </span>
                                                            ) : null}
                                                        </div>
                                                    </th>
                                                )
                                            })}
                                        </tr>
                                    ))}
                                </thead>
                                <tbody className="fix-support-table-body" {...getTableBodyProps()}>
                                    {page.map((row, i) => {
                                        prepareRow(row)
                                        let backgroundStyle = {}
                                        const priority = row.original.priority_col

                                        return (
                                            <tr {...row.getRowProps()} key={i} style={backgroundStyle}>
                                                {row.cells.map((cell, index) => (
                                                    <td
                                                        key={index}
                                                        className={`t-col-${index + 1} ${cell.column.className} ${priority == "High" ? "highPriority" : ""
                                                            }`}
                                                        {...cell.getCellProps()}
                                                    >
                                                        {cell.render("Cell")}
                                                    </td>
                                                ))}
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </div>

                        <Row className="justify-content-md-end justify-content-center align-items-center">
                            <NewPagination
                                gotoPage={gotoPage}
                                canPreviousPage={canPreviousPage}
                                previousPage={previousPage}
                                canNextPage={canNextPage}
                                pageIndex={pageIndex}
                                pageOptions={pageOptions}
                                pageSize={pageSize}
                                page={page}
                                data={data}
                                nextPage={nextPage}
                            />
                        </Row>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

const CodeReviewQueries = () => {
    const [modal_Access, setAccessDenied] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [allData, setAllData] = useState([])
    const token = secureLocalStorage.getItem('auth_token')
    const [ticketDetails, setTicketDetails] = useState({})
    const [replyTiket, setReplyTiket] = useState(false)
    const [replyWidth, setReplyWidth] = useState(0)

    const toggleLoading = loading => {
        setLoading(loading)
    }

    useEffect(() => {
        const updateWidth = () => {
            const viewportWidth = window.innerWidth
            setReplyWidth(viewportWidth * 0.98)
        }
        updateWidth()
        window.addEventListener("resize", updateWidth)
        return () => window.removeEventListener("resize", updateWidth)
    }, [])

    const getData = async () => {
        const res = await fetchNodeData(
            toggleLoading,
            `codeReviewQueries`,
            token
        )
        if (res?.status) {
            setData(res?.data)
            setAllData(res?.data)
        }

    }
    useEffect(() => {
        if (data?.length == 0) {
            getData()
        }
    }, [])

    const onChangeStatus = (id, status) => {
        Swal.fire({
            icon: "warning",
            title: "Are you sure ?",
            text: `You want to Ignore this Review`,
            showCancelButton: true,
            confirmButtonText: "Yes! Done",
        }).then(async data => {
            if (data?.isConfirmed) {
                const res = await FetchNodePostData(
                    toggleLoading,
                    `codeReviewStatus/${id}/${status}`,
                    token,
                    {}
                )
                if (res?.data?.status) {
                    Swal.fire({
                        icon: "success",
                        text: `Code Review Ignored Successfully`,
                    }).then(data => {
                        setData(res?.data?.data?.filter(((obj) => obj?.dev_status == "query")))
                        setAllData(res?.data?.data?.filter(((obj) => obj?.dev_status == "query")))
                    })
                }
            }
        })
    }
    const column1 = useMemo(
        () => codeReviewQueriesColumn(onChangeStatus),
        []
    )

    return (
        <React.Fragment>
            {isLoading && <Loader />}
            <div className="">
                <div>
                    <Row>
                        <Col lg="12">
                            <Card>
                                <div className="responsive-table">
                                    <TableContainer
                                        columns={column1}
                                        data={data}
                                        toggleLoading={toggleLoading}
                                        allData={allData}
                                        setData={setData}
                                    />
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Reply Ticket  */}
            <div className={`note-sticky-form ${replyTiket ? "d-block" : "d-none"}`}>
                <Draggable handle=".modal-header" cancel=".modal-body">
                    <ResizableBox
                        width={replyWidth}
                        style={{
                            position: "fixed",
                            top: "5%",
                            right: "0.5%",
                            zIndex: "1055",
                            backgroundColor: "#fff",
                            maxHeight: "fit-content",
                            transform: "translate(-50%, -50%)",
                        }}
                    >
                        <div className="modal-header p-0 mb-3 border-0">
                            <h5 className="modal-title mt-0 text-dark">Reply Ticket - {ticketDetails?.id} </h5>
                            <span
                                aria-hidden="true"
                                className="btn-modal-span cursor-pointer"
                                onClick={() => setReplyTiket(false)}
                            >
                                &times;
                            </span>
                        </div>

                        <div className="modal-body  ps-0 overflow-hidden">
                            <ReplyIndex
                                ticketDetails={ticketDetails}
                                replyTiket={replyTiket}
                            />
                        </div>
                    </ResizableBox>
                </Draggable>
            </div>

            <AccessDeniedPopup
                modal_Access={modal_Access}
                setAccessDenied={setAccessDenied}
            />
        </React.Fragment>
    )
}

export default CodeReviewQueries
